var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167 168",
    width: 187,
    height: 187,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "salud-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #d8a568 } \n\t\t.s1 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m24.7 8.9h103.6c9.1 0 16.6 7.4 16.6 16.6v103.6c0 9.1-7.5 16.6-16.6 16.6h-103.6c-9.2 0-16.6-7.5-16.6-16.6v-103.6c0-9.2 7.4-16.6 16.6-16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Salud",
    className: "s1",
    "aria-label": "Salud",
    d: "m65.3 124.7c0-3.1-4.5-1.7-4.5-3.9 0-0.9 0.7-1.4 1.6-1.3 1 0 1.5 0.6 1.6 1.2h1.2c-0.1-1.3-1.2-2.2-2.8-2.2-1.6 0-2.8 1-2.8 2.3 0 3.2 4.6 1.7 4.6 4 0 0.8-0.7 1.4-1.7 1.4-1.2 0-1.7-0.7-1.7-1.4h-1.2c0 1.3 1.2 2.3 2.9 2.3 1.8 0 2.8-1.2 2.8-2.4zm1.2-1c0 2 1.3 3.4 3.1 3.4 1.2 0 2-0.6 2.4-1.3v1.2h1.1v-6.6h-1.1v1.2c-0.3-0.7-1.2-1.3-2.4-1.3-1.8 0-3.1 1.3-3.1 3.4zm5.5 0c0 1.5-1 2.4-2.2 2.4-1.2 0-2.2-0.9-2.2-2.4 0-1.6 1-2.4 2.2-2.4 1.2 0 2.2 0.9 2.2 2.4zm3 3.3h1.1v-8.9h-1.1zm8.8-6.6h-1.1v3.7c0 1.4-0.8 2.1-1.9 2.1-1.1 0-1.8-0.7-1.8-2v-3.8h-1.1v3.9c0 1.9 1.2 2.8 2.7 2.8 0.9 0 1.7-0.4 2.1-1.1v1h1.1zm1.4 3.3c0 2 1.4 3.4 3.1 3.4 1.2 0 2.1-0.6 2.5-1.3v1.2h1.1v-8.9h-1.1v3.5c-0.5-0.8-1.4-1.3-2.5-1.3-1.7 0-3.1 1.3-3.1 3.4zm5.6 0c0 1.5-1 2.4-2.3 2.4-1.2 0-2.2-0.9-2.2-2.4 0-1.6 1-2.4 2.2-2.4 1.3 0 2.3 0.9 2.3 2.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m104.8 46.5c4.6 0 8.3 3.7 8.3 8.3v37.8c0 4.6-3.7 8.3-8.3 8.3h-56.6c-4.6 0-8.3-3.7-8.3-8.3v-37.8c0-4.6 3.7-8.3 8.3-8.3h10.3v-3.3c0-4.6 4.3-8.3 9.6-8.3h16.8c5.2 0 9.6 3.7 9.6 8.3v3.3zm4.8 8.3c0-2.7-2.2-4.9-4.8-4.9h-56.7c-2.7 0-4.9 2.2-4.9 4.9v37.8c0 2.7 2.2 4.9 4.9 4.9h56.7c2.6 0 4.8-2.2 4.8-4.9zm-47.8-11.6v3.4h5v-1.5c0-2.7 2.5-4.9 5.6-4.9h8.1c3 0 5.5 2.2 5.5 4.9v1.5h5v-3.4c0-2.7-2.8-4.9-6.2-4.9h-16.7c-3.5 0-6.3 2.2-6.3 4.9zm20.8 1.9c0-0.8-1-1.5-2.1-1.5h-8.2c-1.1 0-2.1 0.7-2.1 1.5v1.5h12.4c0 0 0-1.5 0-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m91 69.4v8.6c0 0.6-0.4 1.1-1 1.1h-7.5v7.5c0 0.5-0.5 1-1 1h-8.7c-0.5 0-1-0.5-1-1v-7.5h-7.5c-0.6 0-1-0.5-1-1.1v-8.6c0-0.6 0.4-1 1-1h7.5v-7.6c0-0.5 0.5-1 1-1h8.7c0.5 0 1 0.5 1 1v7.6h7.5c0.6 0 1 0.4 1 1zm-2 1h-7.5c-0.6 0-1-0.5-1-1v-7.5h-6.7v7.5c0 0.5-0.4 1-1 1h-7.5v6.6h7.5c0.6 0 1 0.5 1 1v7.5h6.7v-7.5c0-0.5 0.4-1 1-1h7.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalud);
export default __webpack_public_path__ + "static/media/salud.1db1a78d0091a2d77950dd9bd1b76945.svg";
export { ForwardRef as ReactComponent };